<template>
    <div v-show="visible">
        <el-dialog title="自定义输出报告" :close-on-click-modal="false"
            v-loading="loading"
            :element-loading-text="loadingText"
            :visible.sync="visible" :before-close="dialogClose" width="350px">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <el-form-item prop="reportType" label="报告分类">
                    <el-select v-model="form.reportType"
                        :disabled="!form.buttonType == 2"
                        clearable placeholder="请选择" style="width: 150px;">
                        <el-option
                            v-for="item in reportTypes"
                            :key="item.operaType"
                            :label="item.name"
                            :value="item.operaType">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  prop="beginDate" label="开始日期">
                    <el-date-picker
                        :disabled="!form.buttonType == 2"
                        v-model="form.beginDate"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        style="width: 150px;"
                        type="date"
                        placeholder="开始日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item  prop="endDate" label="结束日期">
                    <el-date-picker
                        :disabled="!form.buttonType == 2"
                        v-model="form.endDate"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        style="width: 150px;"
                        type="date"
                        placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="save()" v-if="form.buttonType == 1">生成报告</el-button>
                <el-button type="primary" @click="viewReport()" v-if="form.buttonType == 2">查看报告</el-button>
                <el-button @click="visible=false">关闭</el-button>
            </span>
        </el-dialog>
        <!-- 报告查看弹框 -->
        <el-dialog title="查看报告" :visible.sync="reportDialogVisible" width="80%" top="5vh">
            <iframe v-if="reportDialogVisible" :src="reportUrl" style="width:100%; height:70vh; border:none;"></iframe>
            <span slot="footer" class="dialog-footer">
                <el-button @click="reportDialogVisible=false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../../common/http';

    export default {
        data(){
            return{
                loading:false,
                loadingText:"",
                visible: false,
                form:{
                    deptId: "",
                    reportType: "",
                    startDate: "",
                    endDate: "",
                    buttonType: 1
                },
                reportTypes:[],
                reportUrl: "",
                reportDialogVisible: false,
                rules: {
                    reportType: [
                        { required: true, message: '请选择报告分类', trigger: 'blur' }
                    ],
                    beginDate: [
                        { required: true, message: '请选择开始日期', trigger: 'blur' }
                    ],
                    endDate: [
                        { required: true, message: '请选择结束日期', trigger: 'blur' }
                    ]
                }
            }
        },
        methods:{
            init(deptId){
                this.visible=true
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields()
                }
                this.form.buttonType = 1
                this.form.deptId=deptId
                this.customGenerateReportType()
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            // 自定义生成报告分类
            customGenerateReportType(){
                let url= this.headmasterReportCustomGenerateReportTypeUrl;
                let data = {
                    deptId:this.form.deptId,
                };
                this.apiPost(url, data).then((res) => {
                    if(res.status === 200){
                        this.reportTypes = res.data
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                }, (err) => {
                    console.log(err);
                });
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let gradeNames =""
                        let operaType=""
                        for(let i=0; i<this.reportTypes.length;i++){
                            let tempOperaType = this.reportTypes[i].operaType
                            if(tempOperaType == this.form.reportType){
                                gradeNames = this.reportTypes[i].gradeNames
                                operaType = this.reportTypes[i].operaType
                                break
                            }
                        }

                        let url= this.classWeekReportCustomGenerateReportUrl;
                        let data = {
                            deptId: this.form.deptId,
                            gradeNames: gradeNames,
                            operaType: operaType,
                            beginDate: this.form.beginDate,
                            endDate: this.form.endDate
                        };
                        this.loading = true
                        this.loadingText = "生成报告过程时间可能会比较长，请耐心等待"
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.reportUrl = res.data;
                                this.form.buttonType = 2
                                this.$commonFn.showTip(res.message,1);
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading = false
                        }, (err) => {
                            console.log(err);
                            this.loading = false
                        });
                    }
               });
            },
            // 查看报告
            viewReport(){
                if(this.$util.isEmpty(this.reportUrl)){
                    this.$commonFn.showTip('报告链接为空，请先生成报告', 3)
                    return
                }
                this.reportDialogVisible = true;
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/classWeekReport/customReport.vue